import { useState } from "react"
import Input from "../../../../ui/molecules/input"
import { CustomRadio } from "../../../../ui/molecules/radioButton"
import { SelectCustom } from "../../../../ui/molecules/select"
import Button from "../../../../ui/molecules/button"
import { FilieraOptions, ProcessingActivityOptions, ProcessingMethodTypeOptions } from "../../../../utils"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { setProcessingActivity, setProcessingClassificazione, setProcessingCuaa, setProcessingFiliera, setProcessingnotificationId, setProcessingPrintAble, setProcessingUnitType, thirdPatyProcessingCreate } from "./slice"

interface Props {
    close: () => void
}

export function ContoTerziPopupAdd(props: Props) {
    const [printExclude, setPrintExclude] = useState<string | null>(null)
    const thirdPartyState = useAppSelector(state => state.notificationThirdParty)
    const dispatch = useAppDispatch()
    dispatch(setProcessingnotificationId('1'))

    return (
        <div className="bg-brandPrimary-100 pr-5 pl-5 pt-4 pb-12" style={{ borderTopWidth: 1 }}>
            <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                <div style={{ flex: '0.5' }}>
                    <Input
                        label={'Unità Produttiva'}
                        placeholder="Specifica unità..."
                        onChangeText={(text) => { dispatch(setProcessingUnitType(text)) }}
                    />
                </div>
                <div style={{ flex: '0.5' }}>
                    <Input
                        label={'CUAA Terzista'}
                        placeholder="Specifica cuaa..."
                        onChangeText={(text) => { dispatch(setProcessingCuaa(text)) }}
                    />
                </div>
            </div>

            <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                <div style={{ flex: '0.5' }}>
                    <div className="text-left">
                        <span className="input-label">Filiera</span>
                    </div>
                    <SelectCustom
                        placeholder='Specifica filiera...'
                        errorLabel="Filiera mancante"
                        options={FilieraOptions}
                        value={thirdPartyState.createProcessing.production}
                        onChange={(value) => { dispatch(setProcessingFiliera(value)) }}
                    />
                </div>
                <div style={{ flex: '0.5' }}>
                    <div className="text-left">
                        <span className="input-label">Attività</span>
                    </div>
                    <SelectCustom
                        placeholder='Specifica attività...'
                        errorLabel="Attività mancante"
                        // error={}
                        options={ProcessingActivityOptions}
                        value={thirdPartyState.createProcessing.activity}
                        onChange={(value) => { dispatch(setProcessingActivity(value)) }}
                    />
                </div>
            </div>

            <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                <div style={{ flex: '0.5' }}>
                    <div className="text-left">
                        <span className="input-label">Classificazione</span>
                    </div>
                    <SelectCustom
                        placeholder='Specifica classificazione...'
                        errorLabel="Classificazione mancante"
                        options={ProcessingMethodTypeOptions}
                        // value={}
                        onChange={(value) => { dispatch(setProcessingClassificazione(value)) }}
                    />
                </div>
                <div className="pt-7" style={{ display: 'flex', gap: '12px', flex: '0.5' }}>
                    <div className="text-left">
                        <span className="measure-text-bold">Escludi Stampa</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <CustomRadio
                            options={[
                                { label: ' Sì', value: 'Sì' }
                            ]}
                            selectedValue={printExclude}
                            onChange={(value) => {
                                setPrintExclude('Si')
                                dispatch(setProcessingPrintAble(true))
                            }}
                            id={'exclude_1'}
                            name={'exclude_1'}
                        />
                        <CustomRadio
                            options={[
                                { label: ' No', value: 'No' }
                            ]}
                            selectedValue={printExclude}
                            onChange={(value) => {
                                setPrintExclude('No')
                                dispatch(setProcessingPrintAble(false))
                            }}
                            id={'exclude_2'}
                            name={'exclude_2'}
                        />
                    </div>
                </div>
            </div>
            <div className="pt-3 pr-3" style={{ display: 'flex', gap: '24px', justifyContent: 'flex-end' }}>
                <Button
                    color="orange"
                    variant="solid"
                    size="md"
                    iconPosition="off"
                    label="Salva"
                    onClick={() => {
                        dispatch(thirdPatyProcessingCreate(thirdPartyState.createProcessing))
                    }}
                />
            </div>
        </div>
    )
}